import React from 'react';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

function SkeletonMain() {
    return (
        <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>

            {/* Left panel skeleton */}
            <Box sx={{
                width: '35%',
                minWidth: 340,
                bgcolor: '#330000',
                display: 'flex',
                flexDirection: 'column',
                p: 5,
            }}>
                {/* Logo */}
                <Skeleton variant="rectangular" width={220} height={40} sx={{ bgcolor: 'rgba(255,255,255,0.12)', borderRadius: 1 }} />

                {/* Welcome content */}
                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 1.5 }}>
                    <Skeleton variant="rectangular" width={100} height={11} sx={{ bgcolor: 'rgba(255,255,255,0.15)', borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={200} height={48} sx={{ bgcolor: 'rgba(255,255,255,0.18)', borderRadius: 1 }} />
                    <Box sx={{ width: 40, height: 3, bgcolor: 'rgba(204,0,0,0.5)', borderRadius: 1, my: 0.5 }} />
                    <Skeleton variant="rectangular" width={280} height={14} sx={{ bgcolor: 'rgba(255,255,255,0.08)', borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={240} height={14} sx={{ bgcolor: 'rgba(255,255,255,0.08)', borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={200} height={14} sx={{ bgcolor: 'rgba(255,255,255,0.08)', borderRadius: 1 }} />
                </Box>

                {/* Footer */}
                <Skeleton variant="rectangular" width={180} height={11} sx={{ bgcolor: 'rgba(255,255,255,0.06)', borderRadius: 1 }} />
            </Box>

            {/* Right panel skeleton */}
            <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                bgcolor: '#f5f5f7',
                overflow: 'auto',
            }}>
                {/* Top bar */}
                <Box sx={{ px: 3, pt: 2, pb: 1 }}>
                    <Skeleton variant="circular" width={36} height={36} />
                </Box>

                {/* Form card */}
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    px: 3,
                    py: 4,
                }}>
                    <Box sx={{
                        bgcolor: 'white',
                        borderRadius: 3,
                        p: 5,
                        width: '100%',
                        maxWidth: 420,
                        boxShadow: '0 4px 32px rgba(0,0,0,0.08)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                    }}>
                        {/* Title */}
                        <Skeleton variant="rectangular" width={100} height={28} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width={180} height={14} sx={{ borderRadius: 1, mb: 1 }} />

                        {/* System field */}
                        <Skeleton variant="rectangular" width={52} height={13} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />

                        {/* Version field */}
                        <Skeleton variant="rectangular" width={58} height={13} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />

                        {/* Language field */}
                        <Skeleton variant="rectangular" width={68} height={13} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />

                        {/* Confirm button */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                            <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
                        </Box>

                        {/* Divider */}
                        <Skeleton variant="rectangular" width="100%" height={1} sx={{ borderRadius: 1, mt: 0.5 }} />

                        {/* Sign out */}
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
                        </Box>
                    </Box>
                </Box>

                {/* Legal footer */}
                <Box sx={{ textAlign: 'center', pb: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.75 }}>
                    <Skeleton variant="rectangular" width={260} height={12} sx={{ borderRadius: 1 }} />
                    <Skeleton variant="rectangular" width={120} height={12} sx={{ borderRadius: 1 }} />
                </Box>
            </Box>
        </Box>
    );
}

export default SkeletonMain;
